import React from 'react';
import Header from '@elements/header';
import { Button } from '@ss/mtd-react-mobile';
import useGo from '@utils/navigate';
import SubFooter from '@elements/subFooter';
// @ts-ignore
import NotFoundPng from '@imgs/404.png';
import './index.scss';

export default function NotFound() {
  const { replace } = useGo();
  return (
    <div className="zp_mobile_notFound">
      <Header text="美团.招聘" isShowMenu isSticky isShowLogo />
      <div className="zp_mobile_notFound_png">
        <img src={NotFoundPng} alt="404" />
      </div>
      <div className="zp_mobile_not_found_text">没有找到页面</div>
      <div className="zp_mobile_not_found_sub_text">你访问的页面没有找到，请返回首页重试</div>
      <div className="zp_mobile_not_found_btn">
        <Button
          type="primary"
          onClick={() => {
            replace('/home');
          }}
        >
          返回首页
        </Button>
      </div>
      <SubFooter style={{ paddingTop: '117px' }} />
    </div>
  );
}
